var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_48_1053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#B7A2FF",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3334 68.5467C67.4401 68.6667 67.4401 68.9201 67.3334 69.0667C66.3601 70.0001 64.5467 70.0801 64.0001 70.0801C63.4801 70.0801 61.6667 70.0001 60.7201 69.0667C60.5867 68.9201 60.5867 68.6667 60.7201 68.5467C60.8667 68.4134 61.0934 68.4134 61.2267 68.5467C61.8401 69.1601 63.1067 69.3334 64.0001 69.3334C64.9201 69.3334 66.2134 69.1601 66.8001 68.5467C66.9467 68.4134 67.1734 68.4134 67.3334 68.5467ZM62.3334 65.3867C62.3334 64.6267 61.7067 64.0001 60.9467 64.0001C60.1867 64.0001 59.5601 64.6267 59.5601 65.3867C59.5601 66.1467 60.1867 66.7867 60.9467 66.7734C61.7067 66.7734 62.3334 66.1467 62.3334 65.3867ZM67.0534 64.0001C66.2934 64.0001 65.6667 64.6667 65.6667 65.4001C65.6667 66.1334 66.2934 66.7867 67.0534 66.7867C67.8134 66.7867 68.4401 66.1467 68.4401 65.4001C68.4401 64.6667 67.8134 64.0001 67.0534 64.0001ZM77.3334 64.0001C77.3334 71.3334 71.3334 77.3334 64.0001 77.3334C56.6667 77.3334 50.6667 71.3334 50.6667 64.0001C50.6667 56.6667 56.6667 50.6667 64.0001 50.6667C71.3334 50.6667 77.3334 56.6667 77.3334 64.0001ZM72.8934 64.0001C72.8934 62.9201 72.0001 62.0534 70.9601 62.0534C70.4267 62.0534 69.9467 62.2667 69.6001 62.6001C68.2667 61.6401 66.4401 61.0267 64.4001 60.9467L65.2934 56.7734L68.1867 57.4001C68.2134 58.1334 68.8267 58.7201 69.5734 58.7201C70.3334 58.7201 70.9601 58.0934 70.9601 57.3334C70.9601 56.5734 70.3334 55.9467 69.5734 55.9467C69.0267 55.9467 68.5467 56.2667 68.3334 56.7334L65.0934 56.0401C65.0001 56.0001 64.9067 56.0401 64.8401 56.0934C64.7601 56.1467 64.7201 56.2267 64.7067 56.3201L63.7201 60.9601C61.6534 61.0267 59.7867 61.6401 58.4267 62.6134C58.0801 62.2801 57.6001 62.0801 57.0801 62.0801C56.0001 62.0801 55.1334 62.9467 55.1334 64.0001C55.1334 64.8134 55.6134 65.4801 56.2801 65.7867C56.2534 66.0001 56.2401 66.1601 56.2401 66.3734C56.2401 69.3334 59.7201 71.8001 64.0001 71.8001C68.3067 71.8001 71.8001 69.3734 71.8001 66.3734C71.8001 66.1867 71.7867 66.0001 71.7467 65.7867C72.4134 65.4801 72.8934 64.8001 72.8934 64.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_48_1053",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_1053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_1053",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717093 0 0 0 0 0.635577 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_48_1053"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/Reddit.45f949715a4d9b7139df50d4cf95e610.svg";
export { ForwardRef as ReactComponent };